export const env = {
  get mode(): string {
    return import.meta.env.MODE;
  },
  get isDev(): boolean {
    return import.meta.env.DEV;
  },
  get isProd(): boolean {
    return import.meta.env.PROD;
  },
  get isCi(): boolean {
    return Boolean(import.meta.env.VITE_CI);
  },
  get backendUrl(): string {
    return import.meta.env.VITE_BACKEND_URL;
  },
  get chatApiUrl(): string | undefined {
    return import.meta.env.VITE_CHAT_API_URL;
  },
  get cdnUrl(): string | undefined {
    return import.meta.env.VITE_CDN_URL;
  },
  get rootUrl(): string {
    return import.meta.env.VITE_ROOT_URL;
  },
  get stackManagerUrl(): string | undefined {
    return import.meta.env.VITE_STACK_MANAGER_URL;
  },
  get rcWebApiKey(): string {
    return import.meta.env.VITE_RC_WEB_API_KEY;
  },
  get oneSignalAppId(): string {
    return import.meta.env.VITE_ONESIGNAL_APP_ID;
  },
  get metaPixelId(): string | undefined {
    return import.meta.env.VITE_META_PIXEL_ID;
  },
  get appsFlyerDevKey(): string | undefined {
    return import.meta.env.VITE_APPSFLYER_DEV_KEY;
  },
  get appsFlyerAppId(): string | undefined {
    return import.meta.env.VITE_APPSFLYER_APP_ID;
  },
  get posthogProjectToken(): string {
    return import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;
  },
  get posthogHost(): string {
    return import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
  },
  get posthogReplayPercent(): string | undefined {
    return import.meta.env.VITE_PUBLIC_POSTHOG_REPLAY_PERCENT;
  },
};
